// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".package_title[data-v-4c907998]{font-weight:bolder}.package_info[data-v-4c907998]{margin-left:20px}.field_value[data-v-4c907998]{font-size:13px}", ""]);
// Exports
module.exports = exports;
